module.exports = __webpack_public_path__ + "img/ic-bottom-popup-close.74858919.svg";